import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
export default function Header() {
  const isAuth = useSelector((state) => state.main.isAuthenticated);
  const location = useLocation();

  // Check if the current location is '/login'
  const isLoginPage = location.pathname === "/login";
  return (
    !isLoginPage && (
      <header className="header">
        <NavLink
          to={isAuth ? "/admin/" : "/"}
          className="link"
          activeClassName="active"
        >
          الرئيسية
        </NavLink>
        <NavLink
          to={isAuth ? "/admin/social" : "/social"}
          className="link"
          activeClassName="active"
        >
          الموقع، تواصل
        </NavLink>
        <NavLink
          to={isAuth ? "/admin/services" : "/services"}
          className="link"
          activeClassName="active"
        >
          خدماتنـــا
        </NavLink>
        <NavLink
          to={isAuth ? "/admin/cases" : "/cases"}
          className="link"
          activeClassName="active"
        >
          الحالات المرضيـــة
        </NavLink>
      </header>
    )
  );
}
